import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TrafficLightColor } from 'src/app/analysis/models/criterions/TrafficLightColor';

@Component({
    selector: 'sera-ri-value',
    templateUrl: './sera-ri-value.component.html',
    styleUrl: './sera-ri-value.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraRiValueComponent {
    @Input()
    label?: string;

    @Input()
    value?: number | null;

    @Input()
    color?: TrafficLightColor | null;

    @Input()
    withLabel?: boolean = true;

    @Input()
    size?: 'small' | 'medium' | 'small-table-cell' | 'medium-table-cell' = 'small';

    @Input()
    decimals: number = 1;

    getContainerClass(): string[] {
        const baseClass = 'ri-shi-container';
        const labelClass = this.withLabel ? baseClass + '--with-label' : baseClass + '--no-label';

        const colorMap = {
            [TrafficLightColor.GREEN]: baseClass + '--green',
            [TrafficLightColor.YELLOW]: baseClass + '--yellow',
            [TrafficLightColor.RED]: baseClass + '--red'
        };

        const sizeMap = {
            small: labelClass + '--small',
            medium: labelClass + '--medium',
            'small-table-cell': labelClass + '--small-table-cell',
            'medium-table-cell': labelClass + '--medium-table-cell'
        };

        return [baseClass, labelClass, colorMap[this.color!] || baseClass + '--grey', sizeMap[this.size!]];
    }
}
